<template>
  <Head title="Impressumerklärung"/>

  <div class="max-w-2xl mx-auto px-4">
    <Logo class="mx-auto block my-4"></Logo>

    <h1 class="h1">Impressum</h1>
    Der vorliegende Internetauftritt wird bereitgestellt und verantwortet durch die
    <br><br>
    <div class="font-normal">
      <strong>DGVT-Ausbildungsakademie gemeinnützige GmbH </strong><br>
      Corrensstraße 44/46,<br>
      72076 Tübingen <br>
      HRB: 736057 <br>
      Tel.: <a href="tel:07071943444" class="link">07071/943444</a> <br>
      Fax: 07071/943435 <br>
      E-Mail: <a href="mailto:ruggaber@dgvt.de" class="link">ruggaber@dgvt.de</a> <br>
      Internet: <a href="https://www.dgvt-akademie.de" target="_blank" class="link">www.dgvt-akademie.de <i class="fa fa-external-link"></i></a> <br>
    </div>

    <h2 class="h2">Geschäftsführer:</h2>
    Dipl.-Psych. Günter Ruggaber, Aline Schneider

    <h2 class="h2">1. Haftungsbeschränkung</h2>
    Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt erstellt. Der Anbieter übernimmt
    jedoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Inhalte. Die Nutzung
    der Inhalte der Website erfolgt auf eigene Gefahr des Nutzers. Mit der reinen Nutzung der Anwendung des Anbieters
    kommt keinerlei Vertragsverhältnis zwischen dem Nutzer und dem Anbieter zustande.

    <h2 class="h2">2. Externe Links</h2>
    Diese Anwendung enthält Verknüpfungen zu Websites Dritter („externe Links“). Diese Websites unterliegen der Haftung der jeweiligen
    Betreiber. Der Anbieter hat bei der erstmaligen Verknüpfung der externen Links die fremden Inhalte daraufhin
    überprüft, ob etwaige Rechtsverstöße bestehen. Zu dem Zeitpunkt waren keine Rechtsverstöße ersichtlich. Der Anbieter
    hat keinerlei Einfluss auf die aktuelle und zukünftige Gestaltung und auf die Inhalte der verknüpften Seiten. Das
    Setzen von externen Links bedeutet nicht, dass sich der Anbieter die hinter dem Verweis oder Link liegenden Inhalte
    zu eigen macht. Eine ständige Kontrolle der externen Links ist für den Anbieter ohne konkrete Hinweise auf
    Rechtsverstöße nicht zumutbar. Bei Kenntnis von Rechtsverstößen werden jedoch derartige externe Links unverzüglich
    gelöscht.

    <h2 class="h2">    3. Urheber- und Leistungsschutzrechte</h2>
    Die in dieser Anwendung veröffentlichten Inhalte unterliegen dem
    deutschen Urheber- und Leistungsschutzrecht. Jede vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene
    Verwertung bedarf der vorherigen schriftlichen Zustimmung des Anbieters oder jeweiligen Rechteinhabers. Dies gilt
    insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw. Wiedergabe von
    Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen. Inhalte und Rechte Dritter sind dabei als
    solche gekennzeichnet. Die unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte oder kompletter Seiten ist
    nicht gestattet und strafbar. Lediglich die Herstellung von Kopien und Downloads für den persönlichen, privaten und
    nicht kommerziellen Gebrauch ist erlaubt.

    <h2 class="h2">4. Besondere Nutzungsbedingungen</h2>
    Soweit besondere Bedingungen für einzelne Nutzungen dieser Website von den vorgenannten Nummern 1. bis 3. abweichen, wird an entsprechender Stelle
    ausdrücklich darauf hingewiesen. In diesem Falle gelten im jeweiligen Einzelfall die besonderen Nutzungsbedingungen.

    <h2 class="h2">5. Online-Streitbeilegung</h2>
    Die Europäische Kommission stellt unter ec.europa.eu/consumers/odr/ eine Plattform zur
    Online-Streitbeilegung bereit, die Verbraucher für die Beilegung einer Streitigkeit nutzen können und auf der
    weitere Informationen zum Thema Streitschlichtung zu finden sind.

    <h2 class="h2">6. Außergerichtliche Streitbeilegung</h2>
    Wir sind weder verpflichtet noch dazu bereit, im Falle einer Streitigkeit mit einem Verbraucher an einem
    Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.

    <h2 class="h2">Umsetzung und technische Betreuung</h2>
    Darius Mozgiel <br>
    Internet: <a href="https://www.mozgiel.de" class="link">www.mozgiel.de <i class="fa fa-external-link"></i></a>

    <h2 class="h2">DGVT-Fuchs – mein Prüfungstrainer</h2>
    ist ein Angebot
    der DGVT-­AusbildungAkademie gGmbH Kontakt <a href="mailto:campus@dgvt.de" class="link">Bei technischen oder inhaltlichen Fragen zur Plattform schreibe gerne
    eine E-Mail an: campus@dgvt.de</a>

    <div class="mb-20"></div>
  </div>
</template>

<script>
import Logo from '../../Shared/Logo.vue'
import Layout from '../../Shared/Layout.vue'
import {Head} from '@inertiajs/inertia-vue3'

export default {

  name: 'Impressum',

  components: {
    Logo,
    Head,
  },

  layout: Layout,
}
</script>

<style scoped>

</style>